import { render, staticRenderFns } from "./SortingChecklistQuestion.vue?vue&type=template&id=f090a9f4"
import script from "./SortingChecklistQuestion.vue?vue&type=script&lang=js"
export * from "./SortingChecklistQuestion.vue?vue&type=script&lang=js"
import style0 from "./SortingChecklistQuestion.vue?vue&type=style&index=0&id=f090a9f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports